import axios from "axios";
import React, { useEffect, useState } from "react";

export const useGetInfoTeam  = ()=>{
    const [teamInfo, setteamInfo] = useState('')
    const idTeam = window.location?.pathname?.split('/')?.[3]
    console.log('id', idTeam)

    useEffect(()=>{
        if(!idTeam) return
        const url = 'https://web-production-58ed.up.railway.app/api/dt/get/oneteam'
        axios.post(url, {equipo: idTeam}).then(res=> {
            setteamInfo(res?.data?.equipo)
        }).catch(e=> console.log('e', e))

    },[idTeam])

    return{
        teamInfo
    }
}